import React from 'react';
import PropTypes from 'prop-types';
import { 
	handles,
} from 'components/Playlist';
import {
  mathMultiply,
  mathDivide,
} from '@/utils/common';

/**
 * 允许拖拽组件
 */
export default class Drag extends React.Component {
  static propTypes = {
    divcompare: PropTypes.number.isRequired,
    children: PropTypes.element.isRequired
  };
  static defaultProps = {
    //默认是移动children dom,覆盖该方法，可以把tranform行为同步给外部
    updatePosition: (tx, ty, tdom, divcompare) => {
      tx = mathMultiply(tx, divcompare);
      ty = mathMultiply(ty, divcompare);

      tdom.style.left = `${tx}px`;
      tdom.style.top = `${ty}px`;
    },
    updateSize: (tw, th, tdom, divcompare) => {
      tw = mathMultiply(tw, divcompare);
      th = mathMultiply(th, divcompare);

      tdom.style.width = `${tw}px`;
      tdom.style.height = `${th}px`;
    }
  };
  constructor(props){
    super(props);
    this.state = {
      parent: null,
      self: null,
    };

    this.position = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      startX: 0,
      startY: 0,
    }

    this.position2 = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    }
  }

  dragStart = event => {
    document.addEventListener('mouseup', this.dragEnd);
    let { children, area, } = this.props;
    if(2 !== area.areaType && 18 !== area.areaType ){
      event.stopPropagation();//与textarea默认输入冲突
      event.preventDefault();
    }
    // if (event.button !== 0) {
    //   //只允许左键，右键问题在于不选择conextmenu就不会触发mouseup事件
    //   return;
    // }
    if(this.props.type !== 'scene'){
      document.addEventListener('mousemove', this.dragMove);
    }

    let { pageX, pageY } = event;
    this.position = {
      ...area,
      startX: pageX,
      startY: pageY,
    }
    let { left, top, width, height, } = this.position;
    this.position2 = { left, top, width, height, };
    children.props.onDrag && children.props.onDrag({
      ...this.position,
    });
  };
  dragMove = event => {
    event.stopPropagation();
    event.preventDefault();
    
    let { 
      area,
      children, 
      divcompare, 
      templatewidth: parentWidth,
      templateheight: parentHeight, 
    } = this.props;
    
    let { pageX, pageY } = event;
    let { left, top, width, height, startX, startY } = this.position;
    let distanceX = mathDivide(pageX - startX, divcompare);
    let distanceY = mathDivide(pageY - startY, divcompare);
    left = distanceX + left;
    top = distanceY + top;
    if(left < 0) left = 0;
    if(top < 0) top = 0;
    if(left + width > parentWidth){
      left = parentWidth - width;
    }
    if(top + height > parentHeight){
      top = parentHeight - height;
    }
    
    this.position2 = { left, top, width, height, };
    // this.props.updatePosition(left, top, this.tdom, divcompare);
    children.props.onDrag && children.props.onDrag({
      ...area,
      ...this.position2,
    });
    this.tdom.style.opacity = "0.7";
  };
  dragEnd = event => {
    // event.stopPropagation();//影响颜色选择的mouseup
    // event.preventDefault();
    if(!this.tdom) return;
    let { area, children, } = this.props;
    this.position = { ...this.position2 };
    children.props.onDrag && children.props.onDrag({
      ...area,
      ...this.position2,
    });
    children.props.onMouseUp && children.props.onMouseUp();
    document.removeEventListener('mousemove', this.dragMove);
    document.removeEventListener('mouseup', this.dragEnd);
    this.tdom.style.opacity = "1";
  };

  resizeStart = event => {
    document.addEventListener('mouseup', this.resizeEnd);
    event.stopPropagation();//不可以取消，影响resize
    event.preventDefault();

    let { children, area } = this.props;
    // if (event.button !== 0) {
    //   //只允许左键，右键问题在于不选择conextmenu就不会触发mouseup事件
    //   return;
    // }
    document.addEventListener('mousemove', this.resizeMove);
    
    let { 
      target: self,
      pageX,
      pageY,
    } = event;

    this.setState({
      self,
    })
    this.position = {
      ...area,
      startX: pageX,
      startY: pageY,
      className: self.className
    }
    let { left, top, width, height, } = this.position;
    this.position2 = { left, top, width, height, };
    children.props.onChange && children.props.onChange({
      ...this.position,
    });
  };

  resizeMove = event => {
    event.stopPropagation();
    event.preventDefault();
    
    let { 
      area,
      children, 
      divcompare,
      templatewidth: parentWidth,
      templateheight: parentHeight,  
    } = this.props;

    let { areaType } = area;
    if (areaType === 3 || areaType === 4 || areaType === 5) return;
    let { pageX, pageY } = event;
    let { self, } = this.state;
    let { left, top, width, height, startX, startY } = this.position;
    let bottom = top + height;
    let right = left + width;
    let distanceX = mathDivide(pageX - startX, divcompare);
    let distanceY = mathDivide(pageY - startY, divcompare);
    // 判断方向  left, top, width, height, left + width, top + height
    switch(self.className) 
    {
      case 'rRightDown':
        width = distanceX + width;
        height = distanceY + height;
        if(width < 0) {
          width = 0;
        }
        if(height < 0) {
          height = 0;
        }
        if(left + width > parentWidth){
          width = parentWidth - left;
        }
        if(top + height > parentHeight){
          height = parentHeight - top;
        }
        break;
      case 'rLeftDown': 
        left = distanceX + left;
        width = right - left;
        height = distanceY + height;
        if(left < 0){
          left = 0;
          width = right;
        }
        if(width < 0) {
          width = 0;
          left = right;
        }
        if(height < 0) {
          height = 0;
        }
        if(top + height > parentHeight){
          height = parentHeight - top;
        }
        break;
      case 'rLeftUp':
        left = distanceX + left;
        top = distanceY + top;
        width = right - left;
        height = bottom - top;
        if(left < 0){
          left = 0;
          width = right;
        }
        if(top < 0){
          top = 0;
          height = bottom;
        }
        if(width < 0) {
          width = 0;
          left = right;
        }
        if(height < 0) {
          height = 0;
          top = bottom;
        }
        break;
      case 'rRightUp':
        width = distanceX + width;
        top = distanceY + top;
        height = height - distanceY;
        if(top < 0){
          top = 0;
          height = bottom;
        }
        if(width < 0) {
          width = 0;
        }
        if(height < 0){
          height = 0;
          top = bottom;
        }
        if(left + width > parentWidth){
          width = parentWidth - left;
        }
        break;
      case 'rUp':
        top = distanceY + top;
        height = height - distanceY;
        if(height < 0){
          height = 0;
          top = bottom - height;
        }
        if(top < 0){
          top = 0;
          height = bottom - top;
        }
        break;
      case 'rRight':
        width = distanceX + width;
        if(width < 0) width = 0;
        if(left + width > parentWidth){
          width = parentWidth - left;
        }
        break;
      case 'rDown':
        height = distanceY + height;
        if(height < 0) height = 0;
        if(top + height > parentHeight){
          height = parentHeight - top;
        }
        break;
      case 'rLeft':
        left = distanceX + left;
        width = width - distanceX;
        if(width < 0){
          width = 0;
          left = right - width;
        }
        if(left < 0){
          left = 0;
          width = right - left;
        }
        break;
      default:
        console.log('default', self)
    }
    
    this.position2 = { left, top, width, height, className: self.className, };
    // this.props.updateSize(width, height, this.tdom, divcompare);
    children.props.onChange && children.props.onChange({
      ...area,
      ...this.position2,
    });
    this.tdom.style.opacity = "0.7";
  };

  resizeEnd = event => {
    // event.stopPropagation();//影响颜色选择的mouseup
    // event.preventDefault();
    if(!this.tdom) return;
    let { area, children, } = this.props;
    
    this.position = { ...this.position2 };
    children.props.onChange && children.props.onChange({
      ...area,
      ...this.position2,
    });
    document.removeEventListener('mousemove', this.resizeMove);
    document.removeEventListener('mouseup', this.resizeEnd);
    this.tdom.style.opacity = "1";
  };

  componentDidMount() {
    if(!this.tdom) return;
    this.tdom.childNodes.forEach(ele => {
      let index = handles.findIndex(handle => {
        return handle === ele.className;
      })
      if(ele.className === 'div-img'){
        this.tdom.addEventListener('mousedown', this.dragStart);
        // document.addEventListener('mouseup', this.dragEnd);
      }else if(index >= 0){
        ele.addEventListener('mousedown', this.resizeStart);
        // document.addEventListener('mouseup', this.resizeEnd);
      }
    });
  }
  componentWillUnmount() {
    if(!this.tdom) return;
    this.tdom.childNodes.forEach(ele => {
      let index = handles.findIndex(handle => {
        return handle === ele.className;
      })
      if(ele.className === 'div-img'){
        this.tdom.removeEventListener('mousedown', this.dragStart);
        document.removeEventListener('mousemove', this.dragMove);
        document.removeEventListener('mouseup', this.dragEnd);
      }else if(index >= 0){
        ele.removeEventListener('mousedown', this.resizeStart);
        document.removeEventListener('mousemove', this.resizeMove);
        document.removeEventListener('mouseup', this.resizeEnd);
      }
    });
  }
  render() {
    const { children, type } = this.props;
    let newStyle = {
      ...children.props.style,
      cursor: 'move',
      userSelect: 'none'
    };
    if(type === 'scene'){
      // newStyle.cursor = 'not-allowed';
      newStyle.cursor = 'pointer';
    }
    return React.cloneElement(React.Children.only(children), {
      ref: tdom => {
        return (this.tdom = tdom);
      },
      style: newStyle
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Drag/Drag.js